import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const URL = `https://tools.hubteam${enviro.isQa() ? 'qa' : ''}.com/zorse/53/dashboard?newTicket`;
function CreateTicketLink() {
  return /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: URL,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.panel.body.links.createTicket"
    })
  });
}
export default CreateTicketLink;